import * as federation from './federation/auth';
import { USE_FEDERATION } from './federation/config';
import * as legacy from './legacy/auth';
export const SIGN_UP_BY_INVITE = USE_FEDERATION
    ? federation.SIGN_UP_BY_INVITE
    : legacy.SIGN_UP_BY_INVITE;
export const RESET_PASSWORD = USE_FEDERATION
    ? federation.RESET_PASSWORD
    : legacy.RESET_PASSWORD;
export const SING_IN = USE_FEDERATION
    ? federation.SING_IN
    : legacy.SING_IN;
export const GET_USER = USE_FEDERATION
    ? federation.GET_USER
    : legacy.GET_USER;
export const EDIT_USER_LANG = USE_FEDERATION
    ? federation.EDIT_USER_LANG
    : legacy.EDIT_USER_LANG;
export const CHECK_RESET_PASSWORD = USE_FEDERATION
    ? federation.CHECK_RESET_PASSWORD
    : legacy.CHECK_RESET_PASSWORD;
export const DELETE_DRIVER_ACCOUNT = USE_FEDERATION
    ? federation.DELETE_DRIVER_ACCOUNT
    : undefined;
